import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import Cookies from 'js-cookie'
import { ELanguages } from '@enums'

export const supportedLanguages = [ELanguages.EN, ELanguages.RU, ELanguages.UK]
const fallbackLng = ELanguages.UK

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: supportedLanguages,
    fallbackLng: fallbackLng,
    defaultNS: 'translation',
    detection: {
      order: ['cookie', 'htmlTag', 'localStorage', 'path', 'subdomain'],
      caches: ['cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
    backend: {
      // The version query busts browser-cached translations on each deploy;
      // dev server runs without the define, hence the guard.
      loadPath:
        '/locales/{{lng}}/{{ns}}.json?v=' +
        (typeof __I18N_BUILD_ID__ !== 'undefined' ? __I18N_BUILD_ID__ : 'dev'),
    },
    react: {
      useSuspense: true,
    },
  })

const storedLang = Cookies.get('i18next') || fallbackLng
i18n.changeLanguage(storedLang)
Cookies.set('i18next', storedLang)

export default i18n
